import React from "react";

const Careers = () => {

    return (
        <>
            <div className="container mt-5 mb-5 py-4">
                <h1 className="fw-bold">Careers</h1>
                <p>
                    There are no jobs right now.
                </p>
                {/* <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Privacy Policy</h5>
                    </Col>
                    <Col>
                        <p>
                            Learn how we collect, use, and protect your personal information
                            when you interact with our website, apps, and services.
                        </p>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Data Protection Policy</h5>
                    </Col>
                    <Col>
                        <p>
                            An overview of our internal practices and safeguards to ensure the
                            security, confidentiality, and lawful processing of personal data.
                        </p>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Terms of Service</h5>
                    </Col>
                    <Col>
                        <p>
                            The legal agreement that outlines your rights and responsibilities
                            when using our services, placing orders, and interacting with our
                            platform.
                        </p>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Refund & Cancellation Policy</h5>
                    </Col>
                    <Col>
                        <p>
                            Details the conditions under which orders can be cancelled, refunds
                            can be requested, and the process for handling exceptions.
                        </p>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Payment Policy</h5>
                    </Col>
                    <Col>
                        <p>
                            Outlines the accepted payment methods, timing, refund processing,
                            and terms related to promotional discounts.
                        </p>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Delivery & Pickup Policy</h5>
                    </Col>
                    <Col>
                        <p>
                            Explains how our food delivery and cart pickup services operate,
                            including delivery zones, timing, and customer responsibilities.
                        </p>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Cookie and Tracking Policy</h5>
                    </Col>
                    <Col>
                        <p>
                            Describes how we use cookies and tracking technologies to improve
                            your experience and ensure service performance.
                        </p>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-3">
                        <h5 className="fw-bold">Contact & Complaint Policy</h5>
                    </Col>
                    <Col>
                        <p>
                            Information on how to reach our support team and how we handle
                            customer feedback, inquiries, and complaints
                        </p>
                    </Col>
                </Row>
                <hr /> */}
            </div>
            {/* <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 position-relative">
                        <div className="ready-to-feast-image-wrapper">
                            <img
                                src={readyToFeast}
                                alt="Ready to Feast"
                                className="img-fluid rounded-3 mb-4"
                            />

                            <div className="overlay-text text-white text-center">
                                <h1 className="display-4 fw-bold">We’re Always there for you</h1>
                                <p className="lead">
                                    If you have any questions regarding these policies or require further clarification, please contact us at:
                                </p>
                                <div className="contact-button-row mb-3 ">
                                    <ContactInfoButton
                                        icon={EmailSVG}
                                        title="Email Us"
                                        subtitle="support@curryking.lk"
                                    />
                                    <ContactInfoButton
                                        icon={PhoneSVG}
                                        title="Call for Information"
                                        subtitle="+94 11 444 1333"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default Careers;
